import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface AnnouncementConfig {
  message: string;
  actionText?: string;
  actionUrl?: string;
  effectiveDate?: Date;
  expiryDate?: Date;
  enabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AnnouncementBarService {
  private config: AnnouncementConfig;

  constructor() {
    // Load config from environment
    const envAnnouncement = (environment as any).announcement || {};
    this.config = {
      message: envAnnouncement.message || 'announcement.message',
      actionText: envAnnouncement.actionText,
      actionUrl: envAnnouncement.actionUrl,
      effectiveDate: envAnnouncement.effectiveDate ? new Date(envAnnouncement.effectiveDate) : undefined,
      expiryDate: envAnnouncement.expiryDate ? new Date(envAnnouncement.expiryDate) : undefined,
      enabled: envAnnouncement.enabled !== undefined ? envAnnouncement.enabled : false
    };
  }

  getConfig(): AnnouncementConfig {
    return this.config;
  }

  shouldShowAnnouncement(): boolean {
    if (!this.config.enabled) {
      return false;
    }

    const now = new Date();

    // Check effective date
    if (this.config.effectiveDate && now < this.config.effectiveDate) {
      return false;
    }

    // Check expiry date
    if (this.config.expiryDate && now > this.config.expiryDate) {
      return false;
    }

    return true;
  }
}
